export interface NetworkStatusNetwork {
  networkId: number;
  networkName: string;
}

export interface NetworkStatusItem {
  id: number;
  title: string;
  summary: string;
  status: string;
  startDate?: string | null;
  endDate?: string | null;
  createdDate: string;
  updatedDate: string;
  networkIds: number[];
  networks: NetworkStatusNetwork[];
  activeStatuses: string[];
}

export type NetworkStatusSeverity = 'danger' | 'warning' | 'info' | 'success';

export const getNetworkStatusLabel = (status: string): string => {
  switch ((status || '').toUpperCase()) {
    case 'DOWN':
      return 'Service Outage';
    case 'DEGRADED':
      return 'Degraded Performance';
    case 'WARNING':
      return 'Warning';
    case 'INFO':
      return 'Information';
    case 'UP':
      return 'Operational';
    case 'RESOLVED':
      return 'Resolved';
    case 'MONITORING':
      return 'Monitoring';
    case 'INVESTIGATING':
      return 'Investigating';
    case 'IDENTIFIED':
      return 'Identified';
    case 'MAINTENANCE':
      return 'Scheduled Maintenance';
    default:
      return status || 'Unknown';
  }
};

export const getNetworkStatusSeverity = (status: string): NetworkStatusSeverity => {
  switch ((status || '').toUpperCase()) {
    case 'DOWN':
    case 'IDENTIFIED':
      return 'danger';
    case 'DEGRADED':
    case 'WARNING':
    case 'INVESTIGATING':
    case 'MAINTENANCE':
      return 'warning';
    case 'UP':
    case 'RESOLVED':
      return 'success';
    default:
      return 'info';
  }
};
